import React from 'react'
import { useCountdown } from './useCountdown';

const withUseCountdown = Component => (props, state) => {
    const {movieData} = props
    const {limitations} = movieData
    const {visibleFrom} = limitations
    const countdownNumbers = useCountdown(visibleFrom)
    
    return <Component 
        countdownNumbers={countdownNumbers}
        {...props} 
    />
}

export default withUseCountdown
